module.exports = __webpack_public_path__ + "static/logo-white-c14f47c03556eed70d90358acfb4e227.svg";